import React, { Component } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Alert from "react-s-alert";
import { serverApi } from "../../../../config/Keys";

import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import CasualDiningManagementScreen from "./MainScreenTabScreen/CasualDiningManagementScreen";
import FastFoodOtherScreen from "./MainScreenTabScreen/FastFoodOtherScreen";
import { HospitalityHotelManagementScreen } from "./MainScreenTabScreen/HospitalityHotelManagementScreen";
import CasualDiningSeatingManagementScreen from "./InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/CasualDiningSeatingManagementScreen";
import CasualDiningOffersManagement from "./InsidePageScreen/CasualDiningManagementScreen/OffersManagement/CasualDiningOffersManagement";
import CasualDiningScanAndPayScreen from "./InsidePageScreen/CasualDiningManagementScreen/ScanAndPayManagement/CasualDiningScanAndPayScreen";
import CasualDiningEventManagementScreen from "./InsidePageScreen/CasualDiningManagementScreen/EventsManagement/CasualDiningEventManagementScreen";
import { CasualDiningLiveStreamingScreen } from "./InsidePageScreen/CasualDiningManagementScreen/CasualDiningLiveStreamingManagement/CasualDiningLiveStreamingScreen";
import CasualDiningOrderingScreen from "./InsidePageScreen/CasualDiningManagementScreen/OrderingManagement/CasualDiningOrderingScreen";
import { CasualDiningMenuSetupScreen } from "./InsidePageScreen/CasualDiningManagementScreen/MenuSetupManagement/CasualDiningMenuSetupScreen";
import { CasualDiningVoiceService } from "./InsidePageScreen/CasualDiningManagementScreen/VoiceServiceManagement/CasualDiningVoiceService";
import { CasualDiningManageStaffScreen } from "./InsidePageScreen/CasualDiningManagementScreen/ManageStaffManagement/CasualDiningManageStaffScreen";
import OfflineEventsSubscription from "./InsidePageScreen/CasualDiningManagementScreen/EventsManagement/OfflineEvents";
import OnlineEventsSubscription from "./InsidePageScreen/CasualDiningManagementScreen/EventsManagement/OnlineEvents";
import { WalkinWaitlistScreen } from "./InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/WalkinWaitlistScreen";
import { ReservationSeatingScreen } from "./InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/ReservationSeatingScreen";
import GenralSeatingScreen from "./InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/GenralSeatingScreen";
import { TableManagementScreen } from "./InsidePageScreen/CasualDiningManagementScreen/SeatingManagement/TableManagementScreen";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  get_new_subscription_for_vendor,
  update_new_subscription_for_vendor,
} from "../../../../store/actions/authAction";
import isEmpty from "../../../../store/validation/is-Empty";
import store from "../../../../store/store";
import {
  CLEAR_LOADER,
  UPDATE_SUBSCRIPTION_TYPE,
} from "../../../../store/types";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { MainSubscriptionHome } from "../../../superAdminComponents/superAdminAllComponent/SuperAdminAddVendorComponent/subscriptionScreen/MainSubscriptionHome";
import { ReusableOnboardingButton } from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import MultiServiceManagementScreen from "./MainScreenTabScreen/MultiServiceManagementScreen";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { DesktopTabDesign } from "./MainScreenTabScreen/DesktopTabDesign";
import { MobileTabDesign } from "./MainScreenTabScreen/MobileTabDesign";
import Media from "react-media";

export class MainSubscriptionScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      localizationText: "+91IN",
      /********** Tab Management **********/
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
      multiSelectServices: false,

      casual_dining: true,
      fast_food_dining: false,
      hospitality_hotels: false,
      multi_service_business: false,
    };
  }

  componentDidMount() {
    let formDataId = {
      vendor_id: this.props?.auth?.user?.VendorUser?._id,
    };
    this.props.get_new_subscription_for_vendor(formDataId);
    store.dispatch({
      type: CLEAR_LOADER,
    });
    this.setState({
      casual_dining:
        this.props?.tabSubscriptionType?.casualDiningManagement === undefined
          ? this.props?.subscriptionData?.casual_dining
          : this.props?.tabSubscriptionType?.casualDiningManagement,
      fast_food_dining:
        this.props?.tabSubscriptionType?.fastFoodOthersManagement === undefined
          ? this.props?.subscriptionData?.fast_food_dining
          : this.props?.tabSubscriptionType?.fastFoodOthersManagement,
      hospitality_hotels:
        this.props?.tabSubscriptionType?.hospitalityAndHotelsManagement ===
        undefined
          ? this.props?.subscriptionData?.hospitality_hotels
          : this.props?.tabSubscriptionType?.hospitalityAndHotelsManagement,
      multi_service_business:
        this.props?.tabSubscriptionType?.multiSelectServices === undefined
          ? this.props?.subscriptionData?.multi_service_business
          : this.props?.tabSubscriptionType?.multiSelectServices,
    });
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps?.onboarding._id) &&
      !isEmpty(nextProps?.subscriptionData) &&
      !isEmpty(nextProps?.subscriptionData?._id) &&
      !nextState?.hasSetSubscriptionProps
    ) {
      return {
        casual_dining: !isEmpty(nextProps?.subscriptionData?.casual_dining)
          ? nextProps?.subscriptionData?.casual_dining
          : false,
        fast_food_dining: !isEmpty(
          nextProps?.subscriptionData?.fast_food_dining
        )
          ? nextProps?.subscriptionData?.fast_food_dining
          : false,
        hospitality_hotels: !isEmpty(
          nextProps?.subscriptionData?.hospitality_hotels
        )
          ? nextProps?.subscriptionData?.hospitality_hotels
          : false,
        multi_service_business: !isEmpty(
          nextProps?.subscriptionData?.multi_service_business
        )
          ? nextProps?.subscriptionData?.multi_service_business
          : false,
        hasSetSubscriptionProps: true,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  /***********************************************
   * @Desc Tab Next and Back Button Click Handler
   **********************************************/
  tabBackButtonClicked = (e) => {
    if (this.state.multiSelectServices) {
      this.setState({
        casualDiningManagement: false,
        fastFoodOthersManagement: false,
        hospitalityAndHotelsManagement: true,
        multiSelectServices: false,
      });
    } else {
      this.setState({
        casualDiningManagement: true,
        fastFoodOthersManagement: false,
        hospitalityAndHotelsManagement: false,
        multiSelectServices: false,
      });
    }
  };

  tabNextButtonClicked = (e) => {
    if (this.state.hospitalityAndHotelsManagement) {
      this.setState({
        casualDiningManagement: false,
        fastFoodOthersManagement: false,
        hospitalityAndHotelsManagement: false,
        multiSelectServices: true,
      });
    } else {
      this.setState({
        casualDiningManagement: false,
        fastFoodOthersManagement: false,
        hospitalityAndHotelsManagement: true,
        multiSelectServices: false,
      });
    }
  };

  /***********************************************
   * @Desc Tab Button Click Handler
   **********************************************/
  casualDiningManagementButton = (e) => {
    this.setState({
      casual_dining: true,
      fast_food_dining: false,
      hospitality_hotels: false,
      multi_service_business: false,
    });
    const formData = {
      casualDiningManagement: true,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
      multiSelectServices: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
  };

  fastFoodOthersManagement = (e) => {
    this.setState({
      casual_dining: false,
      fast_food_dining: true,
      hospitality_hotels: false,
      multi_service_business: false,
    });
    const formData = {
      casualDiningManagement: false,
      fastFoodOthersManagement: true,
      hospitalityAndHotelsManagement: false,
      multiSelectServices: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
  };
  hospitalityHotelsManagement = (e) => {
    this.setState({
      casual_dining: false,
      fast_food_dining: false,
      hospitality_hotels: true,
      multi_service_business: false,
    });
    const formData = {
      casualDiningManagement: false,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: true,
      multiSelectServices: false,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
  };
  multiServiceManagementButton = (e) => {
    this.setState({
      casual_dining: false,
      fast_food_dining: false,
      hospitality_hotels: false,
      multi_service_business: true,
    });
    const formData = {
      casualDiningManagement: false,
      fastFoodOthersManagement: false,
      hospitalityAndHotelsManagement: false,
      multiSelectServices: true,
    };
    store.dispatch({ type: UPDATE_SUBSCRIPTION_TYPE, payload: formData });
  };

  // onSwitchChange = (event) => {
  //   this.setState({ ...this.state, [event.target.name]: event.target.checked });
  // };

  localProps = {
    casualDiningManagementButton: this.casualDiningManagementButton,
    fastFoodOthersManagement: this.fastFoodOthersManagement,
    hospitalityHotelsManagement: this.hospitalityHotelsManagement,
    multiServiceManagementButton: this.multiServiceManagementButton,
    tabBackButtonClicked: this.tabBackButtonClicked,
    tabNextButtonClicked: this.tabNextButtonClicked,
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    const formData = {};
    console.log(formData);
  };

  render() {
    const {
      casual_dining,
      fast_food_dining,
      hospitality_hotels,
      multi_service_business,
    } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
            >
              <Form noValidate onSubmit={this.onHandleSubmit}>
                <Media query="(min-width: 992px)">
                  <div className="col-12">
                    <BackLogoIconButton
                      displayBackText={true}
                      workWithLinkORClick={true}
                      notDisplaProgressBar={true}
                      displayArrow={true}
                      backButtonClicked={() =>
                        this.props.history.push("/subscriptiondescription")
                      }
                    />
                  </div>
                </Media>
                <Media query="(max-width: 991px)">
                  <MobileTopHeader link={true} onLink={"/subscriptionhome"} />
                </Media>
                <div className="onboarding_process_screen-button-map">
                  <div>
                    <TopTextReusableComponent
                      headingText="Subscription"
                      headingParagraph="Enter the information about the food type provided in your restaurant."
                    />
                  </div>
                  <div>
                    <Media query="(min-width: 768px)">
                      <DesktopTabDesign
                        state={this.state}
                        localProps={this.localProps}
                      />
                    </Media>
                    <Media query="(max-width: 767px)">
                      <MobileTabDesign
                        state={this.state}
                        localProps={this.localProps}
                      />
                    </Media>
                  </div>
                  {casual_dining ? (
                    <CasualDiningManagementScreen
                      localProps={this.localProps}
                      state={this.state}
                      backButtonClicked={() =>
                        this.props.history.push("/subscriptiondescription")
                      }
                    />
                  ) : null || fast_food_dining ? (
                    <FastFoodOtherScreen
                      localProps={this.localProps}
                      state={this.state}
                      backButtonClicked={() =>
                        this.props.history.push("/subscriptiondescription")
                      }
                    />
                  ) : null || hospitality_hotels ? (
                    <HospitalityHotelManagementScreen
                      localProps={this.localProps}
                      state={this.state}
                      backButtonClicked={() =>
                        this.props.history.push("/subscriptiondescription")
                      }
                    />
                  ) : null || multi_service_business ? (
                    <MultiServiceManagementScreen
                      localProps={this.localProps}
                      state={this.state}
                      backButtonClicked={() =>
                        this.props.history.push("/subscriptiondescription")
                      }
                    />
                  ) : null}
                </div>
              </Form>
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                displayHamburger={true}
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../assets/images/illustratorImage/Amealio_Illustrations-02.svg")}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

MainSubscriptionScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
  allSubscriptionsData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state?.auth,
  errors: state?.errors?.errors,
  onboarding: state?.onboarding?.restaurantDetails,
  subscription: state?.onboarding?.onboard_subscription_details,
  subscriptionData:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
  allSubscriptionsData: state?.onboarding?.onboard_subscription_details,
  tabSubscriptionType: state?.onboarding?.subscriptionType,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
  get_new_subscription_for_vendor,
})(withRouter(MainSubscriptionScreen));
